/**
 * Scroll Effects Module - Intersection Observer for smooth reveal animations
 */
export function initScrollEffects() {
  const revealElements = document.querySelectorAll('.reveal-fade-up, .reveal-fade-in');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Animación ocurre una sola vez
      }
    });
  }, {
    threshold: 0.15,
  });

  revealElements.forEach((el) => observer.observe(el));
}
